import { motion } from 'framer-motion';
import './Author.css';
import authorPortrait from './files/SY_Port.jpg';

const pageVariants = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 }
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.6
};

function Author() {
  return (
    <motion.section
      className="author section-container"
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
    >
      <motion.div
        className="author-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        <h2 className="section-title">About the Author</h2>
        <div className="author-info">
          <div className="author-portrait">
            <img src={authorPortrait} alt="Shawn York" className="author-photo" />
            <div className="author-caption">
              <span className="author-name">Shawn York</span>
              <span className="author-role">Author</span>
            </div>
          </div>
          <div className="author-bio">
            <p>
              Shawn York is the franchise Owner-Operator of two Southern California
              Chick-fil-A restaurants. Over the last 20 years in leadership, Shawn
              has been on a mission to build truly sustainable, fulfilling workplaces.
              He has hired and developed over 1,000 Team Members and, using his York
              Framework systems, created a "team that feels like family, in a place
              that feels like home" in fast food. Before writing <em>Love Works Here</em>,
              Shawn began sharing his journey and lessons learned along the way as
              host of the podcast of the same name:{' '}
              <a
                href="https://podcasts.apple.com/us/podcast/love-works-here/id1466029074"
                target="_blank"
                rel="noreferrer"
              >
                <em>Love Works Here</em>
              </a>
              .
            </p>
            <p>
              Shawn earned his bachelor's degree in Music Education from Vanguard
              University, and sings in a world-renowned barbershop quartet. Outside of
              Chick-fil-A and barbershop, he is known to spend his Sundays on a tractor,
              landscaping and working on his vineyard.
            </p>
            <p>
              Shawn lives in Corona, California, with his wife, Lani, and their four
              children.
            </p>
          </div>
        </div>
      </motion.div>
    </motion.section>
  );
}

export default Author;
